import type { EvidenciaImg } from "../types/ot.types";

export const CONTEXTO_EVIDENCIA_INICIO = "STEP_EVIDENCIAS";
export const CONTEXTO_EVIDENCIA_CIERRE = "STEP_EVIDENCIAS_CIERRE";

export const CONTEXTO_REPARACION = [
  CONTEXTO_EVIDENCIA_INICIO,
  CONTEXTO_EVIDENCIA_CIERRE,
] as const;

export interface ArchivoExpediente extends EvidenciaImg {
  contexto?: string;
  referencia_contexto?: string;
}

export function parseEvidenciasReparacionPorConcepto(
  archivos: ArchivoExpediente[],
): {
  inicio: Record<number, EvidenciaImg[]>;
  cierre: Record<number, EvidenciaImg[]>;
} {
  const inicio: Record<number, EvidenciaImg[]> = {};
  const cierre: Record<number, EvidenciaImg[]> = {};

  archivos.forEach((archivo) => {
    const detalleId = Number.parseInt(archivo.referencia_contexto ?? "");
    if (Number.isNaN(detalleId)) return;

    if (archivo.contexto === CONTEXTO_EVIDENCIA_INICIO) {
      if (!inicio[detalleId]) inicio[detalleId] = [];
      inicio[detalleId].push(archivo);
      return;
    }

    if (archivo.contexto === CONTEXTO_EVIDENCIA_CIERRE) {
      if (!cierre[detalleId]) cierre[detalleId] = [];
      cierre[detalleId].push(archivo);
    }
  });

  return { inicio, cierre };
}

export function countEvidenciasReparacion(
  inicio: Record<number, EvidenciaImg[]>,
  cierre: Record<number, EvidenciaImg[]>,
): { inicio: number; cierre: number } {
  const totalInicio = Object.values(inicio).reduce(
    (acc, arr) => acc + arr.length,
    0,
  );
  const totalCierre = Object.values(cierre).reduce(
    (acc, arr) => acc + arr.length,
    0,
  );
  return { inicio: totalInicio, cierre: totalCierre };
}
